import React, { useState, useEffect } from "react";
import { TextInput, Select, Checkbox, Textarea, NumberInput } from '@mantine/core';
import { DatePickerInput } from '@mantine/dates';
import { useController } from 'react-hook-form';
import axios from "axios";
import { Combobox, Loader, useCombobox } from '@mantine/core';
import { useDebouncedCallback } from '@mantine/hooks';
import { FiMapPin } from 'react-icons/fi';
import base_url from "../../api/bootapi";
import { Popover, ActionIcon } from "@mantine/core";
import { DatePicker } from "@mantine/dates";
import { SlCalender } from "react-icons/sl";
import { PiCaretDown } from "react-icons/pi";
import moment from "moment";

export const RHFTextInput = ({ name, control, rules ,isFirstLetter = false, ...props}) => {
   const handleChange = (e) => {
    let value = e.target.value;

    if (isFirstLetter && value.length > 0) {
      value = value.charAt(0).toUpperCase() + value.slice(1);
    }

    field.onChange(value);
  };
  const { field, fieldState: { error } } = useController({ name, control, rules });
  return <TextInput {...field} error={error?.message} {...props}  value={field.value || ""} onChange={handleChange}  styles={{
    label: {
      fontSize: '14px',
      fontWeight: 500,
      color:"#000"
      
    },
    input: {
      height:'40px'
    }
  }} />;
};




export const RHFNumberInput = ({
  name,
  control,
  rules,
  maxLength,
  allowDecimal = false,
  allowNegative = false,
  ...props
}) => {
  const {
    field,
    fieldState: { error },
  } = useController({
    name,
    control,
    rules,
  });

  const handleChange = (e) => {
    let value = e.target.value;

    if (allowDecimal) {
      value = value.replace(
        allowNegative ? /[^0-9.-]/g : /[^0-9.]/g,
        ""
      );

      // Allow only one decimal point
      const parts = value.split(".");
      if (parts.length > 2) {
        value = parts[0] + "." + parts.slice(1).join("");
      }
    } else {
      value = value.replace(
        allowNegative ? /[^0-9-]/g : /[^0-9]/g,
        ""
      );
    }

    // Allow only one minus sign at start
    if (allowNegative) {
      value = value.replace(/(?!^)-/g, "");
    }

    if (maxLength) {
      value = value.slice(0, maxLength);
    }

    field.onChange(value);
  };

  return (
    <TextInput
      {...props}
      value={field.value ?? ""}
      onChange={handleChange}
      error={error?.message}
      inputMode={allowDecimal ? "decimal" : "numeric"}
      styles={{
        label: {
          fontSize: "14px",
          fontWeight: 500,
          color: "#000",
        },
        input: {
          height: "40px",
        },
      }}
    />
  );
};

export const RHFSelect = ({ name, control, rules ,onKeyDown, ...props }) => {
  const { field, fieldState: { error } } = useController({ name, control, rules });
  return <Select
   onKeyDown={onKeyDown}
    comboboxProps={{
                  transitionProps: {
                    transition: 'pop',
                    duration: 150,
                  },
                }} allowDeselect={false} {...field} error={error?.message} {...props} styles={{
    label: {
      fontSize: '14px',
      fontWeight: 500,
      color:"#000"
      
    },
    input: {
      height:'40px'
    }
  }} />;
};

export const RHFCheckbox = ({ name, control, rules, ...props }) => {
  const { field, fieldState: { error } } = useController({ name, control, rules });
  return (
    <Checkbox 
      checked={field.value} 
      onChange={(e) => field.onChange(e.currentTarget.checked)} 
      styles={{
        body: {
          position: 'relative',
        },
        label: {
          fontSize: '15px',
        },
        description: {
          position: 'absolute',
          left: '20px',
          top: '24px',
          fontSize: '12px',
          color: '#666',
          whiteSpace: 'nowrap',
        },
      }}
      error={error?.message} 
      {...props} 
    />
  );
};

export const RHFDatePicker = ({ name, control, rules, ...props }) => {
  const { field, fieldState: { error } } = useController({ name, control, rules });
  return <DatePickerInput {...field} error={error?.message} {...props} />;
};

export const RHFTextarea = ({ name, control, rules, ...props }) => {
  const { field, fieldState: { error } } = useController({ name, control, rules });
  return <Textarea {...field} error={error?.message} {...props} />;
};




export const RHFGoogleAddress = ({ googleAddress, setGoogleAddress, isRequired = true }) => {
  const combobox = useCombobox({
    onDropdownClose: () => combobox.resetSelectedOption(),
  });

  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  
  // Local state for the text input so typing is instantaneous
  const [search, setSearch] = useState("");

  // Keep the local search input in sync if the parent resets or updates the value
  useEffect(() => {
    if (typeof googleAddress === 'object') {
      setSearch(googleAddress?.label || "");
    } else {
      setSearch(googleAddress || "");
    }
  }, [googleAddress]);

  // Debounce the API call so we don't spam the server on every single keystroke
  const fetchSuggestions = useDebouncedCallback(async (query) => {
    if (!query) {
      setData([]);
      setLoading(false);
      return;
    }

    try {
      const response = await axios.get(
        `${base_url.api1}/tourapp/address_suggestion?address=${query}`
      );
      const suggestions = response.data.suggestions.map((suggestion) => ({
        label: suggestion.postal_code
          ? `${suggestion.description}, ${suggestion.postal_code}`
          : suggestion.description,
        value: suggestion.place_id,
      }));
      setData(suggestions);
    } catch (error) {
      console.error("Error fetching suggestions:", error);
      setData([]);
    } finally {
      setLoading(false);
    }
  }, 300); // 300ms delay

  const handleSearchChange = (val) => {
    setSearch(val);
    // Pass the raw string to the parent while they are still typing
    setGoogleAddress(val); 
    
    setLoading(true);
    fetchSuggestions(val);
    combobox.openDropdown();
  };

  const handleOptionSubmit = (optionValue) => {
    const selectedOption = data.find((item) => item.value === optionValue);
    
    if (selectedOption) {
      setSearch(selectedOption.label);
      // Pass the full object { label, value } to the parent, exactly as your logic expects
      setGoogleAddress(selectedOption);
    }
    
    combobox.closeDropdown();
  };

  const options = data.map((item) => (
    <Combobox.Option value={item.value} key={item.value}>
      {item.label}
    </Combobox.Option>
  ));

  return (
    <Combobox
      onOptionSubmit={handleOptionSubmit}
      store={combobox}
      withinPortal={false}
    >
      <Combobox.Target>
        <TextInput
          placeholder="Enter Address"
          value={search}
          onChange={(event) => handleSearchChange(event.currentTarget.value)}
          onClick={() => combobox.openDropdown()}
          onFocus={() => combobox.openDropdown()}
          onBlur={() => combobox.closeDropdown()}
          styles={{
   
    input: {
      height:'40px'
    }
  }}
          required={isRequired}
          leftSection={<FiMapPin size={16} />}
          rightSection={loading ? <Loader size={16} /> : null}
          autoComplete="off"
        />
      </Combobox.Target>

      <Combobox.Dropdown hidden={data.length === 0 && !loading}>
        <Combobox.Options>
          {loading ? (
            <Combobox.Empty>Loading suggestions...</Combobox.Empty>
          ) : options.length > 0 ? (
            options
          ) : (
            <Combobox.Empty>No results found</Combobox.Empty>
          )}
        </Combobox.Options>
      </Combobox.Dropdown>
    </Combobox>
  );
};




export const RHFCustomDatePicker = ({
  value = "",
  onChange,
  error,
  minDate,
  maxDate,
  disabled = false,
  maxYear = new Date().getFullYear(),
}) => {
  const [isOpen, setIsOpen] = useState(false);

  // Auto-format MM/DD/YYYY while typing
  const handleDobChange = (e) => {
    let cleaned = e.target.value.replace(/\D/g, "");
    cleaned = cleaned.slice(0, 8);

    if (cleaned.length > 4) {
      cleaned = cleaned.replace(/^(\d{2})(\d{2})(\d{0,4})/, "$1/$2/$3");
    } else if (cleaned.length > 2) {
      cleaned = cleaned.replace(/^(\d{2})(\d{0,2})/, "$1/$2");
    }

    const parts = cleaned.split("/");
    if (parts.length > 0) {
      let mm = parts[0];
      if (mm && parseInt(mm, 10) > 12) {
        cleaned = "12" + (parts[1] ? "/" + parts[1] : "") + (parts[2] ? "/" + parts[2] : "");
      }
    }
    if (parts.length > 2) {
      let yyyy = parts[2];
      const currentYear = new Date().getFullYear();
      if (yyyy && parseInt(yyyy, 10) > maxYear) {
        cleaned = parts[0] + "/" + parts[1] + "/" + currentYear;
      } else if (yyyy && String(yyyy).length === 4 && parseInt(yyyy, 10) < 1920) {
        cleaned = parts[0] + "/" + parts[1] + "/1920";
      }
    }
    if (parts.length > 1) {
      let dd = parts[1];
      if (dd && parseInt(dd, 10) > 31) {
        cleaned = parts[0] + "/31" + (parts[2] ? "/" + parts[2] : "");
      }
    }
    onChange(cleaned);
  };

  // Convert "MM/DD/YYYY" string into a valid JS Date object for Mantine DatePicker
  const parsedDate = value && value.length === 10 && moment(value, "MM/DD/YYYY", true).isValid()
    ? moment(value, "MM/DD/YYYY").toDate()
    : null;

  return (
    <TextInput
  type="tel"
  placeholder="MM/DD/YYYY"
  value={value}
  onChange={handleDobChange}
  disabled={disabled}
       styles={{
    
    input: {
      height:'40px'
    }
  }}
  leftSection={<SlCalender size={16} />}
  rightSection={
    <Popover
      opened={isOpen}
      onChange={setIsOpen}
      position="bottom-end"
      withArrow
      shadow="md"
    >
      <Popover.Target>
        <ActionIcon
          variant="transparent"
          color="gray"
          onClick={(e) => {
            e.stopPropagation();
            setIsOpen((o) => !o);
          }}
        >
          <PiCaretDown size={16} />
        </ActionIcon>
      </Popover.Target>

      <Popover.Dropdown p="sm">
        <DatePicker
          size="sm"
          value={parsedDate}
          onChange={(date) => {
            if (date) {
              onChange(moment(date).format("MM/DD/YYYY"));
              setIsOpen(false);
            }
          }}
        />
      </Popover.Dropdown>
    </Popover>
  }
/>
  //   <Popover
  //     opened={isOpen}
  //     onChange={setIsOpen}
  //     position="bottom-start"
  //     withArrow
  //     shadow="md"
  //     disabled={disabled}
  //   >
  //     <Popover.Target>
  //       {/* Mantine TextInput natively styles the field and handles left/right icons */}
  //       <TextInput
  //         type="tel"
  //         placeholder="MM/DD/YYYY"
  //         value={value}
  //         onChange={handleDobChange}
  //         disabled={disabled}
  //         styles={{
    
  //   input: {
  //     height:'40px'
  //   }
  // }}
  //         error={error}
  //         onClick={() => !disabled && setIsOpen(true)}
  //         leftSection={<SlCalender size={16} />}
  //         rightSection={
  //           <ActionIcon 
  //             variant="transparent" 
  //             color="gray" 
  //             onClick={(e) => {
  //               e.stopPropagation(); // Prevents input click event from firing simultaneously
  //               if (!disabled) setIsOpen((o) => !o);
  //             }}
  //           >
  //             <PiCaretDown size={16} />
  //           </ActionIcon>
  //         }
  //       />
  //     </Popover.Target>

  //     <Popover.Dropdown p="sm">
  //       <DatePicker
  //         size="sm"
  //         value={parsedDate}
  //         onChange={(date) => {
  //           if (date) {
  //             const formattedDate = moment(date).format("MM/DD/YYYY");
  //             onChange(formattedDate);
  //             setIsOpen(false);
  //           }
  //         }}
  //         minDate={minDate}
  //         maxDate={maxDate}
  //         defaultDate={parsedDate || new Date()}
  //       />
  //     </Popover.Dropdown>
  //   </Popover>
  );
};



